export const grey = "#36353d"
export const vpBlue = "#00549E"
export const vpBlueRGB = "rgb(208,100,62)"
export const black = "#000"
export const lightGrey = "#a1a8ae"
export const white = "#ffffff"
export const footerTextGrey = "#36353d" // "rgb(88,89,91)"
